import { Component, Input, Output, EventEmitter, ElementRef, AfterViewInit } from "@angular/core";

@Component({
  selector: "ds-option",
  templateUrl: "./ds-option.component.html",
  styleUrls: ["./ds-option.component.scss"],
})
export class DsOptionComponent implements AfterViewInit {
  @Input() value: any;
  @Input() multiple = false;
  @Input() disabled = false;
  @Input() error = false;
  @Input() default = false;
  @Input() alwaysVisible = false;
  // Allows long labels to wrap to multiple lines inside the option list.
  @Input() wrap = false;
  @Output() optionSelected = new EventEmitter<DsOptionComponent>();
  selected = false;
  hidden = false;
  highlighted = false;
  displayText = "";
  size = "sm";
  dropdown = false;

  constructor(private elementRef: ElementRef) {}

  get elementRefInstance(): ElementRef {
    return this.elementRef;
  }

  ngAfterViewInit() {
    this.displayText = this.elementRef.nativeElement.textContent?.trim() || "";
  }

  onClick(event: Event) {
    if (this.disabled || this.default) {
      return;
    }
    event.stopPropagation();
    this.selected = !this.selected;
    this.optionSelected.emit(this);
  }
}
